















import { Inject, Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { cloneDeep } from 'lodash'
import { PrintableDocument } from '@/api/model/printable-document'
import { PrintableDocumentAPI } from '@/api/backend-client'

@Component
export default class ListsActions extends Vue {
    @Inject() readonly reload: () => Promise<void>
    @Prop({ required: true }) readonly printableDocument!: PrintableDocument
    @Ref() wrapper: HTMLDivElement
    visible: boolean = false
    value: PrintableDocument = null

    created(): void {
        this.value = cloneDeep<PrintableDocument>(this.printableDocument)
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    async deletePrintableDocument(printableDocument: PrintableDocument): Promise<void> {
        if (confirm(this.$t('company_settings.emma_direct_mail.printable_documents.delete_confirm').toString())) {
            await PrintableDocumentAPI.delete(printableDocument.id)
            await this.reload()
        }
    }

    async navigateToEdit(printableDocument: PrintableDocument): Promise<void> {
        await this.$router.push({
            name: 'company_settings_emma_direct_mail_printable_documents_edit',
            params: {
                printableDocumentId: printableDocument.id,
            },
        })
    }
}
